// extracted by mini-css-extract-plugin
export default {"modalContainer":"styles_modalContainer__4Na91","headerContainer":"styles_headerContainer__gZJSU"};